module.exports = __webpack_public_path__ + "img/more.184a399f.svg";